module.exports = __webpack_public_path__ + "static/media/strongher4_preview.02e57726.jpg";